<template>
  <div class="banner">
    <div class="label">
      <slot />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import '../styles/vars';

.banner {
  display: inline-block;
  position: relative;
  width: 35.75em;
  @media screen and (max-width: 35.75em) {
    width: calc(100% + 1.8em);
  }
  transform: translateX(-0.875rem);
  font-weight: 700;
  z-index: 9;
  &:before {
    content: '';
    position: absolute;
    border-style: solid;
    bottom: -1em;
    left: -1.75rem;
    border-width: 1.625em 1.625em 1.625em 1em;
    border-color: white white white transparent;
    filter: drop-shadow(0 5px 0 rgba(0, 0, 0, 0.2));
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    border-style: solid;
    bottom: -1em;
    right: -1.75em;
    border-width: 1.625em 1em 1.625em 1.625em;
    border-color: white transparent white white;
    filter: drop-shadow(0 5px 0 rgba(0, 0, 0, 0.2));
    z-index: -1;
  }
  .label {
    display: inline-block;
    position: relative;
    padding: 0.5em 0.8em 0.5em;
    width: 100%;
    background-repeat: no-repeat;
    box-shadow: 0px 19px 0 -14px rgba(0, 0, 0, 0.2);
    z-index: 10;
    &:before {
      content: ' ';
      position: absolute;
      bottom: -0.9em;
      left: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0.9em 0.9em 0;
      border-color: transparent rgba(0, 0, 0, 0.2) transparent transparent;
    }
    &:after {
      content: ' ';
      position: absolute;
      bottom: -0.9em;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0.9em 0.9em 0 0;
      border-color: rgba(0, 0, 0, 0.2) transparent transparent transparent;
    }
  }
}

.colorScheme.red & {
  .banner {
    &:before {
      border-color: darken(@colorScheme--red, 5%) darken(@colorScheme--red, 5%) darken(@colorScheme--red, 5%)
        transparent;
    }
    &:after {
      border-color: darken(@colorScheme--red, 5%) transparent darken(@colorScheme--red, 5%)
        darken(@colorScheme--red, 5%);
    }
    .label {
      background: @colorScheme--red;
    }
  }
}

.colorScheme.midGreen & {
  .banner {
    &:before {
      border-color: darken(@colorScheme--midGreen, 5%) darken(@colorScheme--midGreen, 5%)
        darken(@colorScheme--midGreen, 5%) transparent;
    }
    &:after {
      border-color: darken(@colorScheme--midGreen, 5%) transparent darken(@colorScheme--midGreen, 5%)
        darken(@colorScheme--midGreen, 5%);
    }
    .label {
      background: @colorScheme--midGreen;
    }
  }
}
</style>
